import React, {Component} from "react";
import Button from "../button/index";
import Dialog from "./index";

export default class ConfirmQuizDialog extends Component {

    render() {

        return (
            <Dialog active={this.props.visible} addClass={"small"}>
                <h4>{this.props.translate("dialog.heading.confirm")}</h4>
                <div className="dialog-text-wrapper">
                    {this.props.text}{(this.props.name) ? (<span> "{this.props.name}"</span>) : ""}?
                </div>
                <div>
                    <Button className={"btn btn-success btn-sm margin-right-10"}
                            onClick={() => {
                                this.props.submit();
                            }}
                            text={this.props.translate("btn.yes")}
                    />

                    <Button
                        className={"btn btn-default btn-sm"}
                        onClick={() => {
                            this.props.cancel();
                        }}
                        text={this.props.translate("btn.cancel")}
                    />
                </div>
            </Dialog>
        )
    }
}